import { PublicRoutes } from "./routes_constants";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Cookies } from "../utils/cookies";
import jwt_decode from "jwt-decode";
import { ClearStorage, GetItemFromStorage, SetItemInStorage } from "../custom_hooks/useStorage";
import { LocalStorage } from "../custom_hooks/localStorageKeys";
import { config, ROLES } from "../base/constant";
import { v4 as uuidv4 } from "uuid";
import { CoreServices } from "../base/service/apiServices";
import axios from "axios";
import { ChatActions } from "../store/slices/chat_slice/chat_slice";

import { CallService } from "../services/call_service";
import { getAllContactList } from "../store/api/helperspi/contactListapiService";
import { getAllUsers } from "../store/api/user_management";
import { UserSettingsActions } from "../store/slices/settings_slice/user_settings_slice";
import presenceService from "../base/service/presence";
import callChatService from "../base/service/chatService";
import { AgentStateAction } from "../store/slices/agent-status/agent_state";
import store from "../store/redux-store/root_store";
import { outboundCampaignSliceAction } from "../store/slices/outboundCampaign/outboundCampaignslice";
import { hassAccess } from "../base/utils";

const ControlledRoutes = ({ navigate, dispatch }: any) => {
  let tokenData: any = Cookies.get();
  let auth: any = tokenData['ssoToken'] ?? "";
  const decodedToken: any = auth && jwt_decode(auth);
  const location = useLocation();
  const isLoginInitFunc = GetItemFromStorage(LocalStorage.IS_LOGIN_INIT_FUNC);
  // if (!auth && !location.pathname.includes("customervideochat")) {
  //   if (PublicRoutes.has(location?.pathname?.toLowerCase())) {
  //     return <Outlet />;
  //   } else {
  //     return <Navigate to="/login" />;
  //   }
  // } else {
  //   return <Outlet />;
  // }

  // const ringer = () => {
  //   const audio = document.getElementById("ringer") as HTMLAudioElement;
  //   audio.src = process.env.PUBLIC_URL + "/ringtone/ringback.wav";
  //   audio.load(); // This re-evaluates the <source> children
  // };

  if (!auth && (location?.pathname?.includes("customervideochat") || PublicRoutes.has(location?.pathname?.toLowerCase()))) {
    return <Outlet />;
  } else if (auth && decodedToken?.is_cas_user === 1) {
    // ringer();
    const localStorageToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const decodedLocalStorageToken = localStorageToken && jwt_decode(localStorageToken);
    if (!['/', '/login'].includes(location?.pathname?.toLowerCase()) && (!isLoginInitFunc || decodedToken?.Email !== decodedLocalStorageToken?.Email)) {
      loginInitFunc(navigate, dispatch, location);
      return null;
    }
    return <Outlet />;
  } else {
    let shopifyStore = sessionStorage.getItem(LocalStorage.SHOPIFY_CRED);
    let bigcommerceCred = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_CRED);
    let bigcomerceSource = sessionStorage.getItem(LocalStorage.BIGCOMMERCE_SOURCE);
    let wixStore = sessionStorage.getItem(LocalStorage.WIX_CRED);
    Cookies.clear();
    ClearStorage();
    sessionStorage.clear();
    if (shopifyStore || bigcommerceCred || bigcomerceSource || wixStore) {

      if (shopifyStore !== null) {
        sessionStorage.setItem(LocalStorage.SHOPIFY_CRED, shopifyStore);
      }
      if (bigcommerceCred && bigcomerceSource) {
        sessionStorage.setItem(LocalStorage.BIGCOMMERCE_CRED, bigcommerceCred);
        sessionStorage.setItem(LocalStorage.BIGCOMMERCE_SOURCE, bigcomerceSource);
      }
      if (wixStore) {
        console.log('wix store-----');
        console.log("wixStore----", wixStore);
        sessionStorage.setItem(LocalStorage.WIX_CRED, wixStore);
      }
    }
    if (location.pathname !== "/login") {
      return <Navigate to="/login" />;
    }
    return <Outlet />;
  }
};

export default ControlledRoutes;

const updateFlow = async () => {
  CoreServices.get(`/did_purchase_list`).then(async (value: any) => {
    if (value && value.data.statusCode === 200) {
      let contactPurchaseList = value.data.getDidNumberlist.list;
      for (let api of contactPurchaseList) {
        if (api.defaultUpdated === 0 && api.callFlowId == "9876543210") {
          CoreServices.put({ recording: api.recording, callFlowId: api.callFlowId }, `/did_purchase_update/${api.your_number}`)
            .then((response: any) => {
              console.log("updated:", response);
            });
        }
      }
    }
  });
};

const getRandomColor3 = () => {
  let random: number = Math.floor(Math.random() * 10) + 1;
  let className: string = random < 10 ? `profileview color${random}` : "profileview color10";
  return className;
};

const loginInitFunc = async (navigate: any, dispatch: any, location: any) => {
  let tokenData: any = Cookies.get();
  let Authorization: any = tokenData['ssoToken'] ?? "";
  const shopifyCred = sessionStorage.getItem(LocalStorage.SHOPIFY_CRED);
  const { isGetAllcontacts, allContactList } = store.getState().contactListForAgent;
  const { isSocketJoin } = store.getState().chatReducer;

  if (Authorization !== "") {
    console.log('authauthauth', Authorization);
    ClearStorage();
    sessionStorage.clear();
    const auth: any = jwt_decode(Authorization);
    if (auth?.is_cas_user === 1) {
      try {
        // let isValidPlan: boolean = true;
        const { createCallConnection } = CallService(dispatch, navigate);
        import('../components/webChatScreen');
        // setLoader(true);
        // setShowLogin(false);
        SetItemInStorage(LocalStorage.IS_LOGIN_INIT_FUNC, true);
        SetItemInStorage(LocalStorage.ACCESS_TOKEN, Authorization);
        SetItemInStorage(LocalStorage.WSS_URL, config().CALL_SERVER_WSS_URL);
        SetItemInStorage(LocalStorage.VIDEO_WSS_URL, config().VIDEO_CALL_SERVER_WSS_URL);
        SetItemInStorage(LocalStorage.REFRESH_TOKEN, Authorization);
        !isSocketJoin && new callChatService(Authorization, navigate, dispatch);
        !isSocketJoin && new presenceService(Authorization, navigate, dispatch,0);
        let LoginUserDetails: any = jwt_decode(Authorization);
        let uuidNew: any = uuidv4();
        if (!GetItemFromStorage("deviceid")) {
          SetItemInStorage("deviceid", uuidNew);
        } else {
          uuidNew = GetItemFromStorage("deviceid");
        }
        SetItemInStorage(LocalStorage.ROLE_ID, LoginUserDetails?.ccas_role_info);
        SetItemInStorage(LocalStorage.PRODUCT_ID, LoginUserDetails.product_id);
        SetItemInStorage(LocalStorage.PLAN_ID, LoginUserDetails.parent_id);
        LoginUserDetails.roleId = LoginUserDetails?.ccas_role_info;

        const userObject = {
          username: LoginUserDetails.Email,
          password: "",
          source: "CCAAS:BROWSER",
          ipAddress: "136.144.56.255:443",
          isForceLogin: false,
          deviceId: uuidNew,
        };

        let data = {
          "company_id": LoginUserDetails.companyId
        }
        let loginUserDetails: any = {}
        const loginTime: number = Date.now();
        SetItemInStorage(LocalStorage.LOGIN_TIME, loginTime);
        const isAnotherUserLoggedIn: any = await new Promise((resolve) => {

          const timeout = setTimeout(() => resolve({ status: '500', message: "Server did not respond" }), 5000);
          callChatService?.io?.emit('multi_login_restriction',
            {
              email: LoginUserDetails?.Email,
              ext: LoginUserDetails?.ext,
              domainId: LoginUserDetails?.domain_id,
              loginTime: loginTime,
              source: 'CCAAS:BROWSER',
            },
            (response: any) => {
              clearTimeout(timeout);
              resolve(response);
            }
          );
        }).catch((error: any) => console.log('isAnotherUserLoggedIn errrrrrrr', error));
        const allowMultipleUser = tokenData['allowMultipleLogin'];
        if (isAnotherUserLoggedIn?.status === '200' || allowMultipleUser) {
          try {
            Cookies.set('allowMultipleLogin', true, 1);
            callChatService.io.emit('update_inactivity_presence', false);
            await CoreServices.get(`/get_user_details_email`)
              .then((response: any) => {
                if (response?.data.statusCode === 200 && Array.isArray(response?.data.getUserDetailsRes) && response?.data.getUserDetailsRes.length > 0) {
                  var chatflag: any = response.data.getUserDetailsRes[0].chatFlag === null ? 0 : response.data.getUserDetailsRes[0].chatFlag;
                  LoginUserDetails["isChattour"] = chatflag;
                  loginUserDetails = response.data.getUserDetailsRes[0];
                  SetItemInStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS, response.data.getUserDetailsRes[0]);
                  dispatch(outboundCampaignSliceAction.setUserCallInfo(response?.data?.getUserDetailsRes?.[0]?.outboundCampaignCall ?? 0))
                } else {
                  Cookies.clear();
                  ClearStorage();
                  localStorage.clear();
                  sessionStorage.clear();
                  navigate("/login", { replace: true });
                  return;
                }
              })
              .catch((error) => {
                console.log("get_user_details_email>>>", error);
              });
          } catch (error) {
            console.log("get_user_details_email error>>>>", error)
          }

          let chatTour: any = LoginUserDetails?.isChattour === 0 && (LoginUserDetails?.kevin_plan?.plan_id === 33 || LoginUserDetails?.kevin_plan?.plan_id === 55 || LoginUserDetails?.kevin_plan?.plan_id === 56 || LoginUserDetails?.kevin_plan?.plan_id === 96 || LoginUserDetails?.kevin_plan?.plan_id === 97 || LoginUserDetails?.kevin_plan?.plan_id === 103 || LoginUserDetails?.kevin_plan?.plan_id === 107 || LoginUserDetails?.kevin_plan?.plan_id === 120 || LoginUserDetails?.kevin_plan?.plan_id === 121 || LoginUserDetails?.kevin_plan?.plan_id === 122 || LoginUserDetails?.kevin_plan?.plan_id === 123 || LoginUserDetails?.kevin_plan?.plan_id === 124 || LoginUserDetails?.kevin_plan?.plan_id === 77 || LoginUserDetails?.kevin_plan?.plan_id === 78 || LoginUserDetails?.kevin_plan?.plan_id === 127 || LoginUserDetails?.kevin_plan?.plan_id === 128 || LoginUserDetails?.kevin_plan?.plan_id === 133 || LoginUserDetails?.kevin_plan?.plan_id === 131 || LoginUserDetails?.kevin_plan?.plan_id === 130) ? true : false

          if (chatTour && LoginUserDetails.roleId === ROLES.ADMIN_ROLE_ID) {
            navigate("/chatbotonboarding");
          } else {
            if (LoginUserDetails?.roleId === ROLES.ADMIN_ROLE_ID || LoginUserDetails.roleId === ROLES.OWNER_ROLE_ID || LoginUserDetails.roleId === ROLES.SUB_OWNER_ROLE_ID) {
              if (shopifyCred) { navigate('/shopifystorecheck') }
              else {
                // LoginUserDetails?.product_id === "15" ? navigate("/standaloneDashboard") : navigate("/dashboard");
                hassAccess("Dashboard/dynamicDash") 
                  ?  navigate('/dynamicdashboard')
                  :  navigate('/dashboard'); 
              }
            } else if (LoginUserDetails.roleId === ROLES.SUPERVISOR_ROLE_ID) {
              // LoginUserDetails?.product_id === "15" ? navigate("/standaloneDashboard") : navigate("/dashboard");
              hassAccess("Dashboard/dynamicDash") 
                ?  navigate('/dynamicdashboard')
                :  navigate('/dashboard'); 
            } else {
              // LoginUserDetails?.product_id === "15" ? navigate("/agentdashboardstandalone") : navigate("/agentdashboard")
              hassAccess("Dashboard/dynamicDash") 
                ?  navigate('/dynamicdashboard')
                :  navigate('/dashboard'); 
            }
          }
          await axios.post(`${config().MYACCOUNTSERVICE_URL}/billing/getBillServicePlan`, data).then((res: any) => {
            if (res?.data?.result.length > 0) {
              dispatch(ChatActions.servicePlan(res?.data?.result[0]))
              var Kevin_paln: any = res?.data?.result[0];
              LoginUserDetails["kevin_plan"] = Kevin_paln;
              if (parseInt(Kevin_paln?.product_id) !== 1 && parseInt(Kevin_paln?.product_id) !== 15 && parseInt(Kevin_paln?.product_id) !== 17) { // ccass=1 and bot=15
                Cookies.clear();
                ClearStorage();
                sessionStorage.clear();
                navigate("/login", { replace: true });
                return;
                // } else if (res?.data?.result[0]?.freetrail_rem_days < 0 && window.location.host.includes('worktual')) {
                //   isValidPlan = false;
                //   return;
              }
            }
          }).catch((error: any) => { console.log(error, "error") });
          // if (!isValidPlan) {
          //   Cookies.clear();
          //   ClearStorage();
          //   sessionStorage.clear();
          //   navigate("/login", { replace: true });
          //   return;
          // }
          await updateFlow();
          SetItemInStorage(LocalStorage.USER_EMAIL, userObject?.username.trim());
          SetItemInStorage(LocalStorage.USER_DETAILS, LoginUserDetails);
          // const loginTime: number = Date.now();
          // SetItemInStorage(LocalStorage.LOGIN_TIME, loginTime);
          // setLoading(false);
          SetItemInStorage(LocalStorage.REMEMBER_ME, false);
          CoreServices.get(`/get_user_details/${userObject?.username}`)
            .then((result: any) => {
              if (result?.data.statusCode === 200) {
                SetItemInStorage(LocalStorage.AGENT_EXT, result?.data?.agentExt);
              }
            })
            .catch((error) => { });
          SetItemInStorage("isUpdate", "0");
          createCallConnection();
          // !isGetAllcontacts && allContactList && dispatch(getAllContactList());
          dispatch(getAllUsers());
          let updatedata = {
            isVoice: 0,
            isVoiceCallTransfer: 0,
            isChat: 0,
            isChatTransfer: 0,
            isEmail: 0,
            isEmailTransfer: 0,
            stateTime: Math.floor(Date.now() / 1000),
            statusName: "Not Ready",
          };
          SetItemInStorage(LocalStorage.WORK_STATUS, updatedata.statusName);
          SetItemInStorage(LocalStorage.STATE_CHANGE, updatedata.stateTime);
          axios.put(`${config().BASE_URL}/core_service/v1/update_agent_status_value/${LoginUserDetails.Email}`, updatedata, {
            headers: {
              appId: config().APPID,
              appSecret: config().AppSECRET,
              Authorization: Authorization,
            },
          })
            .then((value: any) => {
              if (value && value.data.statusCode === 200) {
                SetItemInStorage(LocalStorage.WORK_STATUS, updatedata.statusName);
                SetItemInStorage(LocalStorage.STATE_CHANGE, updatedata.stateTime);
              }
            });
          sessionStorage.setItem("logindetails", JSON.stringify(LoginUserDetails));

          dispatch(UserSettingsActions.updateMenuValue({ settingsMenuValue: "cc" }));

          const uuid = uuidv4();
          const date = new Date();
          let timeStamp: any = date.getTime();
          SetItemInStorage("uuid", uuid);
          SetItemInStorage("getRandomColor3", getRandomColor3());
          const body = {
            logInSessionId: uuid,
            logInTimestamp: timeStamp,
          };
          const { agentStatus } = store.getState().agentState;
          const { users } = store.getState().userList;
          const presence = sessionStorage.getItem('presence')
          const currentPresence = (presence === "" || !presence) ? "Not Reaady" : presence
          let status: any = null
          if (agentStatus?.length > 0) {
            [status] = agentStatus.filter((i: any) => { return currentPresence === i?.statusName?.trim() })
          }
          let enableStatus: any = null
          if (users.length > 0) {
            [enableStatus] = users?.filter((i: any) => { return LoginUserDetails.Email === i?.emailId })
          }

          presenceService?.io?.emit("updatestate_backend", {
            domainId: LoginUserDetails?.domainId,
            isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
            isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
            isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
            isChatTransfer: status?.isChatTransfer ?? 0,
            isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
            isEmailTransfer: status?.isEmailTransfer ?? 0,
            stateTime: Math.floor(Date.now() / 1000),
            statusName: currentPresence,
            ext: LoginUserDetails?.ext,
            email: LoginUserDetails?.Email,
            agentStatus: 0,
            userId: LoginUserDetails.UserID,
            routingProfileId: loginUserDetails?.routing_profile_id,
            roleId: loginUserDetails?.roleid,
            skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
            routingMethod: enableStatus?.routingMethod ?? 0
          });
          sessionStorage.setItem('presence', currentPresence)

          dispatch(AgentStateAction.setCurrentStatus({ status: currentPresence }));

          // callChatService?.io?.emit("multi_login_restriction", {
          //   email: LoginUserDetails?.Email,
          //   ext: LoginUserDetails?.ext,
          //   uid: LoginUserDetails?.uuid,
          //   domainId: LoginUserDetails?.domain_id,
          //   loginTime: loginTime,
          //   source: 'CCAAS:BROWSER'
          // });
          CoreServices.post(body, "/insert_login_session_history").catch((e: any) => console.error(e));
        } else {
          Cookies.clear();
          ClearStorage();
          localStorage.clear();
          sessionStorage.clear();
          !['/', '/login'].includes(window.location.pathname) && navigate("/", { replace: true });
        }

      } catch (error) {
        Cookies.clear();
        ClearStorage();
        sessionStorage.clear();
        navigate("/login", { replace: true });
        console.log(error);
      }
    } else {
      Cookies.clear();
      ClearStorage();
      sessionStorage.clear();
      navigate("/login", { replace: true });
    }

  } else {
    Cookies.clear();
    ClearStorage();
    sessionStorage.clear();
    navigate("/login", { replace: true });
  }
  dispatch(ChatActions.reset());
};